var _polygon, _path, _polygon2, _path2, _polygon3, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _circle2, _circle3, _path25, _circle4, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawCodeSnippets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 618.72644,
    height: 633.21397,
    viewBox: "0 0 618.72644 633.21397",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "111.33 615.176 120.809 615.176 125.32 578.614 111.33 578.614 111.33 615.176",
    fill: "#a0616a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.87315,742.07639l15.14391-.90388v6.48831l14.39774,9.94359a4.05285,4.05285,0,0,1-2.303,7.388h-18.0294l-3.10764-6.41793-1.21337,6.41793h-6.79781Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.143 615.176 196.622 615.176 201.134 578.614 187.143 578.614 187.143 615.176",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M474.68661,742.07639l15.14392-.90388v6.48831l14.39773,9.94359a4.05284,4.05284,0,0,1-2.30295,7.388h-18.0294l-3.10764-6.41793-1.21338,6.41793h-6.7978Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.834 391.865 169.231 393.128 169.231 338.66 127.834 338.865 118.834 391.865",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M460.1238,486.04225l6.73691,22.44573,13.985,29.44213L510.388,707.98853l-4.51652,23.52354-43.79516-1.84013L442.571,583.86388l-.31355,20.12929-.15177,9.74307s7.11409,63.36941-1.17866,75.66755-.169,10.85124-.169,10.85124l-.39516,25.36862-51.89175.368,11.44806-73.03688s5.813-4.58987,2.70288-9.20363,3.01439-10.26442,3.01439-10.26442l-2.74689-57.0179s3.04141-9.84859-.53614-11.12872-.46969-9.74944-.46969-9.74944l-.53168-11.0361,11.77182-44.51233Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M411.2887,472.05335l-5.15237-15.45711-3.68027-5.15237-1.4721-14.72106c0-39.74687,8.86574-33.12819,8.86574-33.12819l11.56447-13.97921,13.15673-.41115,10.397-.32491,8.64388,14.353,12.5129,4.41632,4.9,25.46027-8.94826,27.16752.39469-2.01877c4.21232,7.77622,3.14074,8.94592-.34725,14.78452l-.17338,2.1083c-.40994,4.98474,3.06393,5.84373-1.82662,6.8917-42,9-46,27-51,20-1.11341-1.55877,3.61131-20.16113,2-20C406.70912,482.48372,411.2887,472.05335,411.2887,472.05335Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 146.39088,
    cy: 228.71023,
    r: 21.83511,
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390.96941,517.8902l2.236-76.91974,14.56328,6.37145-7.26044,70.26791a7.2573,7.2573,0,1,1-9.53883.28038Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M409.58912,403.197l-1.69359.53482a22.32219,22.32219,0,0,0-15.60029,21.28609l-3.18572,14.58725c4.61505,7.91787,11.437,11.8414,20.93471,10.92245Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M509.13928,429.74677a7.25086,7.25086,0,1,0-13.899,2.89049l-14.2799,22.50167V441.64266l-16.10844,1.74146,2.25488,24.05245a9.07942,9.07942,0,0,0,16.94694,3.615l19.30267-34.203A7.25313,7.25313,0,0,0,509.13928,429.74677Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M463.54571,406.81353l1.62014.51162a21.35406,21.35406,0,0,1,14.9237,20.36289l3.04755,13.95461c-4.41486,7.57447-10.941,11.32782-20.02673,10.44874Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M409.00122,366.98006c1.21944-4.64173,1.67788-9.49953,3.43961-13.96371a25.345,25.345,0,0,1,45.5142-3.38782,17.26433,17.26433,0,0,1,2.4976,11.22625c-.69492,4.26138-3.51755,8.31324-2.63376,12.53951.59126,2.82735,2.72684,5.024,4.42243,7.36248s3.03436,5.43126,1.81256,8.04869c-1.32688,2.84255-5.01235,3.68286-8.138,3.41605-3.12563-.26686-6.25638-1.276-9.34189-.70991l1.46929-5.758q-5.48623,5.28051-10.97242,10.561c.40494-3.66373-1.29728-7.17926-2.47123-10.67339s-1.72136-7.70512.60463-10.56463c1.39105-1.71019,3.53426-2.57431,5.44743-3.66949s3.81165-2.7351,4.00662-4.93092c.2411-2.71514-2.19164-4.894-4.58056-6.20657-2.389-1.31268-5.14026-2.41327-6.48125-4.78641q1.44376,3.09894,2.88748,6.19792a18.24294,18.24294,0,0,1-15.1323-10.24677l-1.31878.86348c-10.96456,12.29623,3.07658,30.71969-5.15475,37.16634C418.49319,383.01824,407.1234,374.128,409.00122,366.98006Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 513.81834,
    y: 153,
    width: 326,
    height: 594,
    rx: 58.72835,
    transform: "translate(-389.03331 72.42474) rotate(-16.13524)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M695.973,141.005l-26.19722,7.57889,2.61823,9.05015a16.07875,16.07875,0,0,1-10.977,19.91374L544.374,211.40852a16.07876,16.07876,0,0,1-19.91374-10.977l-2.61822-9.05015-26.19722,7.5789a53.289,53.289,0,0,0-36.33926,65.92425L591.73947,722.65571A53.28875,53.28875,0,0,0,657.66373,758.995l200.32813-57.95524a53.28874,53.28874,0,0,0,36.33926-65.92425L761.89721,177.34429A53.28906,53.28906,0,0,0,695.973,141.005Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M469.74793,326.16807a4.00458,4.00458,0,0,1-4.954-2.73081l-2.22325-7.68487a4,4,0,1,1,7.68487-2.22324l2.22325,7.68486A4.00459,4.00459,0,0,1,469.74793,326.16807Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M481.148,365.57365a4.00458,4.00458,0,0,1-4.95406-2.73081l-6.11989-21.154a4,4,0,1,1,7.68487-2.22325l6.11989,21.154A4.00457,4.00457,0,0,1,481.148,365.57365Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M490.31294,397.25309a4.00457,4.00457,0,0,1-4.95405-2.73081l-6.1199-21.154a4,4,0,0,1,7.68487-2.22325l6.11989,21.154A4.00457,4.00457,0,0,1,490.31294,397.25309Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M800.3902,288.80914a4.00458,4.00458,0,0,1-4.95405-2.73082l-14.93281-51.61675a4,4,0,0,1,7.68487-2.22324l14.9328,51.61675A4.00458,4.00458,0,0,1,800.3902,288.80914Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M545.62828,316.92337a1.49595,1.49595,0,0,1-1.06747-.08969l-19.40415-9.34777a1.49993,1.49993,0,0,1-.70028-2.00243l9.34778-19.40415a1.5,1.5,0,1,1,2.70271,1.30214l-8.6967,18.0528L545.863,314.131a1.5,1.5,0,0,1-.23468,2.7924Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#17df97"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M556.65772,313.69137a1.5,1.5,0,0,1-1.66019-2.28082L566.22078,294.81l-16.60023-11.22385a1.49981,1.49981,0,1,1,1.68034-2.48478L569.144,293.16525a1.49947,1.49947,0,0,1,.40222,2.08256L557.48231,313.0909A1.49153,1.49153,0,0,1,556.65772,313.69137Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#17df97"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M753.16959,278.00647,524.27274,344.22668a13.874,13.874,0,0,1-17.16382-9.46117l-12.86236-44.46a13.874,13.874,0,0,1,9.46117-17.16382l228.89685-66.22021a13.874,13.874,0,0,1,17.16382,9.46117l12.86236,44.46A13.874,13.874,0,0,1,753.16959,278.00647Zm-248.906-2.94359a11.872,11.872,0,0,0-8.09576,14.68679l12.86236,44.46a11.872,11.872,0,0,0,14.68679,8.09577l228.89685-66.22022a11.872,11.872,0,0,0,8.09576-14.68679l-12.86235-44.46a11.87206,11.87206,0,0,0-14.6868-8.09577Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M634.04582,266.66486l-38.42433,11.11622a4,4,0,0,1-2.22325-7.68487L631.82258,258.98a4,4,0,0,1,2.22324,7.68487Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M722.77207,263.89837l-121.99727,35.294a4,4,0,0,1-2.22325-7.68487l121.99727-35.294a4,4,0,1,1,2.22325,7.68487Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M632.38946,620.90894a1.49358,1.49358,0,0,1-1.06747-.08969l-19.40415-9.34778a1.49992,1.49992,0,0,1-.70028-2.00243l9.34777-19.40415a1.5,1.5,0,0,1,2.70272,1.30215l-8.6967,18.05279,18.05279,8.6967a1.5,1.5,0,0,1-.23468,2.79241Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#17df97"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M643.419,617.6774a1.50019,1.50019,0,0,1-1.66065-2.28068L652.982,598.79556l-16.60036-11.22432a1.49981,1.49981,0,0,1,1.68035-2.48478l17.84322,12.06436a1.49989,1.49989,0,0,1,.40268,2.08242L644.24409,617.0768A1.49642,1.49642,0,0,1,643.419,617.6774Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#17df97"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M858.21787,641.11645,629.321,707.33667a13.874,13.874,0,0,1-17.16382-9.46117L579.00774,583.29105a13.874,13.874,0,0,1,9.46117-17.16382L817.36576,499.907a13.874,13.874,0,0,1,17.16382,9.46117L867.679,623.95263A13.874,13.874,0,0,1,858.21787,641.11645Zm-269.19315-73.068a11.87174,11.87174,0,0,0-8.09576,14.6868l33.14946,114.58445a11.87174,11.87174,0,0,0,14.68679,8.09576l228.89685-66.22021a11.87174,11.87174,0,0,0,8.09576-14.6868L832.60836,509.924a11.87174,11.87174,0,0,0-14.68679-8.09576Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M720.807,570.65042l-38.42434,11.11622a4,4,0,1,1-2.22324-7.68486l38.42434-11.11622a4,4,0,0,1,2.22324,7.68486Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M809.53325,567.88394,687.536,603.17793a4,4,0,1,1-2.22325-7.68486L807.31,560.19907a4,4,0,0,1,2.22325,7.68487Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 529.55741,
    y: 402.9659,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-382.6874 32.24922) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 620.8431,
    y: 376.5568,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-371.75228 56.57772) rotate(-16.13524)",
    fill: "#17df97"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 646.70738,
    y: 369.07423,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-368.654 63.47079) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 553.3226,
    y: 389.03081,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-377.02515 44.32596) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 675.03686,
    y: 353.81869,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-362.44499 76.76396) rotate(-16.13524)",
    fill: "#f2f2f2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 535.60702,
    y: 422.64968,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-387.91933 34.70581) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 626.89271,
    y: 396.24058,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-376.98421 59.03431) rotate(-16.13524)",
    fill: "#17df97"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 652.75699,
    y: 388.75801,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-373.88592 65.92739) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 559.37221,
    y: 408.71459,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-382.25707 46.78255) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 681.08647,
    y: 373.50247,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "matrix(0.96061, -0.27791, 0.27791, 0.96061, -367.67691, 79.22055)",
    fill: "#f2f2f2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 589.68705,
    y: 428.43818,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-387.39769 49.96297) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 680.97275,
    y: 402.02909,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-376.46257 74.29147) rotate(-16.13524)",
    fill: "#17df97"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 706.83703,
    y: 394.54651,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-373.36428 81.18455) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 613.45225,
    y: 414.5031,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-381.73543 62.03971) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 735.1665,
    y: 379.29097,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "matrix(0.96061, -0.27791, 0.27791, 0.96061, -367.15527, 94.47771)",
    fill: "#f2f2f2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 557.79982,
    y: 500.48416,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-408.67575 43.93934) rotate(-16.13524)",
    fill: "#17df97"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 583.6641,
    y: 493.00159,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-405.57747 50.83241) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 612.41627,
    y: 479.20712,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-399.75785 64.3006) rotate(-16.13524)",
    fill: "#f2f2f2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 618.68748,
    y: 461.43533,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-395.4254 59.32216) rotate(-16.13524)",
    fill: "#17df97"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 644.55176,
    y: 453.95275,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "matrix(0.96061, -0.27791, 0.27791, 0.96061, -392.32712, 66.21523)",
    fill: "#17df97"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 551.58967,
    y: 475.37041,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-401.08766 47.24542) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 673.30392,
    y: 440.15829,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "matrix(0.96061, -0.27791, 0.27791, 0.96061, -386.5075, 79.68342)",
    fill: "#f2f2f2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 595.01369,
    y: 446.85025,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-392.30468 52.16855) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 686.29939,
    y: 420.44116,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-381.36956 76.49705) rotate(-16.13524)",
    fill: "#17df97"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 712.16367,
    y: 412.95858,
    width: 17.43164,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-378.27127 83.39013) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 619.20158,
    y: 434.37624,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-387.03181 64.42031) rotate(-16.13524)",
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 740.91584,
    y: 399.16412,
    width: 60.76425,
    height: 9.12266,
    rx: 2.87996,
    transform: "translate(-372.45165 96.85831) rotate(-16.13524)",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.98491,
    cy: 324.13719,
    r: 4.5,
    fill: "#17df97"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.7047,
    cy: 305.88563,
    r: 4.5,
    fill: "#17df97"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M607.63287,179.93451,577.854,188.54958a2.5,2.5,0,0,1-1.38953-4.803l29.77886-8.61507a2.5,2.5,0,1,1,1.38953,4.803Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.67106,
    cy: 39.69349,
    r: 2,
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M325.0115,765.25182a10.94684,10.94684,0,0,1-.56348-2.33105.756.756,0,0,1-.01318-.17578c-.50928-4.8418,1.99023-9.33106,4.82226-13.88672l3.88281-6.23828a3.43916,3.43916,0,0,1,6.28077,1.08594c.21093.96875.42187,1.95117.62353,2.93066,2.09033-1.73926,4.27295-3.34863,6.18408-4.73926q7.57032-5.49316,15.13623-10.999a3.43688,3.43688,0,0,1,5.41016,3.3623l-.96,5.56641c-1.2749,7.38476-2.71973,15.75488-6.13819,23.07324-.38281.83789-.79248,1.65332-1.21679,2.42285l-.14258.25879H325.13064Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#f0f0f0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.82124,766.29967l616.3575.30731a1.19069,1.19069,0,0,0,0-2.38134l-616.3575-.30732a1.19069,1.19069,0,0,0,0,2.38135Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#cacaca"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M717.01784,653.841a17.07856,17.07856,0,1,1,11.65959-21.152A17.07858,17.07858,0,0,1,717.01784,653.841Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M718.27674,633.94419l-4.855,1.40454-1.40456-4.855a1.68471,1.68471,0,1,0-3.2367.93639l1.40456,4.855-4.855,1.40456a1.68469,1.68469,0,0,0,.93637,3.23665l4.855-1.40456,1.40456,4.855a1.68471,1.68471,0,1,0,3.2367-.93638l-1.40456-4.855,4.855-1.40455a1.68469,1.68469,0,0,0-.93637-3.23665Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M765.01625,639.955a17.07856,17.07856,0,1,1,11.65958-21.152A17.07857,17.07857,0,0,1,765.01625,639.955Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M766.27514,620.05818l-4.85494,1.40454-3.23671.93638-4.855,1.40456a1.68469,1.68469,0,0,0,.93637,3.23666l4.855-1.40456,3.23671-.93639,4.85494-1.40454a1.68469,1.68469,0,1,0-.93637-3.23665Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M813.01465,626.069a17.07856,17.07856,0,1,1,11.65959-21.152A17.07856,17.07856,0,0,1,813.01465,626.069Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#e6e6e6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M817.27255,606.21371l-6.61492-5.443a1.4359,1.4359,0,1,0-1.8247,2.2176l4.27809,3.52018-3.69243,1.06822-3.23669.93638-4.855,1.40456a1.68469,1.68469,0,1,0,.93637,3.23666l4.855-1.40456,3.23669-.93638,3.84043-1.111-1.82331,5.51941a1.43591,1.43591,0,0,0,2.72687.90083l2.687-8.1341a1.89473,1.89473,0,0,0-.51343-1.77473Z",
    transform: "translate(-290.63678 -133.39302)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCodeSnippets);
export default __webpack_public_path__ + "static/media/undraw_code_snippets.2b966c647591c92319b369854b8c8b30.svg";
export { ForwardRef as ReactComponent };